import host from './host'
import { getDefaultPort } from './host'
import { pageArgs } from '@/utils'

export function getPort() {
  return pageArgs.args().port['default'] || getDefaultPort()// 设置默认线上服务
}

/**
 * 设置模型结构
 * @param { Id } options 参数
 */
export function Model(options) {
  this.options = options
  return this
}

// 设置ID的字段名称
Model.prototype.setId = function(Id) {
  this.Id = Id
  return this
}
// 从data中获取ID的值
Model.prototype.getId = function(data) {
  const Id = this.Id
  const value = data && data[Id]
  return value
}
// 从data中获取ID的值的对象
Model.prototype.dataId = function(data, fields) {
  const Id = this.Id
  return {
    ...fields,
    [Id]: this.getId(data)
  }
}

// 设置模型使用的接口
Model.prototype.usePath = function() {
  return host.path(...arguments)
}
